<template>
  <div class="page_content">
    <el-form label-width="100px" size="small">
      <div class="content">
        <div class="label">新用户赠送</div>
        <el-form-item label="余额">
          <el-input class="input_box" v-model="formData.balance"></el-input>
        </el-form-item>
        <el-form-item label="积分">
          <el-input class="input_box" v-model="formData.point"></el-input>
        </el-form-item>
        <el-form-item label="优惠券">
          <el-tag
            v-for="(tag, index) in sList"
            :key="tag.id"
            closable
            @close="delTagItem(index)"
            style="margin-bottom:5px;margin-right:5px;"
          >
            <!-- {{ tag.name }} -->
            {{ tag.name }}
            <span v-if="tag.choseNum != 1">
              <span class="colorRed">×</span>
              {{ tag.choseNum }} 张</span
            >
          </el-tag>
          <el-button @click="showSelecter=true">选择</el-button>
        </el-form-item>
      </div>
      <div class="content">
        <div class="label">推广人赠送</div>
        <el-form-item label="余额">
          <el-input class="input_box" v-model="formData.share_balance"></el-input>
        </el-form-item>
        <el-form-item label="积分">
          <el-input class="input_box" v-model="formData.share_point"></el-input>
        </el-form-item>
        <el-form-item label="优惠券">
          <el-tag
            v-for="(tag, index) in sList2"
            :key="tag.id"
            closable
            @close="delTagItem2(index)"
            style="margin-bottom:5px;margin-right:5px;"
          >
            <!-- {{ tag.name }} -->
            {{ tag.name }}
            <span v-if="tag.choseNum != 1">
              <span class="colorRed">×</span>
              {{ tag.choseNum }} 张</span
            >
          </el-tag>
          <el-button @click="showSelecter2=true">选择</el-button>
        </el-form-item>
      </div>
      <div class="content">
        <div class="label">分享内容</div>
        <el-form-item label="分享标题">
          <el-input class="input_box" v-model="formData.share_title"></el-input>
        </el-form-item>
        <el-form-item label="分享海报">
          <el-upload
            name="image"
            :data="imgdata"
            class="avatar-uploader"
            :show-file-list="false"
            accept="image/jpeg,image/gif,image/png"
            :action="uploadUrl"
            :on-success="handleLogoSuccess"
            :before-upload="beforeLogoUpload"
          >
            <img v-if="imageUrl" :src="imageUrl" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
      </div>
    </el-form>
    <div class="align_c">
      <el-button type="">取消</el-button>
      <el-button type="primary" @click="save()">确定</el-button>
    </div>
    <el-dialog :visible.sync="showSelecter" @close="showSelecter = false" width="900px">
      <newSelectCommodityNum
        @close="showSelecter = false"
        @getCommod="getCommod"
        :sList="sList"
        :jude="2"
      ></newSelectCommodityNum>
    </el-dialog>
    <el-dialog :visible.sync="showSelecter2" @close="showSelecter2 = false" width="900px">
      <newSelectCommodityNum
        @close="showSelecter2 = false"
        @getCommod="getCommod2"
        :sList="sList2"
        :jude="2"
      ></newSelectCommodityNum>
    </el-dialog>
  </div>
</template>

<script>
import newSelectCommodityNum from "@/components/commodity/newSelectCommodityNum.vue";
import { mapGetters } from "vuex";
import { getShareConfig,setShareConfig } from "@/api/user"
export default {
  components: {
    newSelectCommodityNum
  },
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  data(){
    return{
      formData: {},
      showSelecter: false,
      showSelecter2: false,
      sList: [], // 已选择优惠券
      sList2: [], // 已选择优惠券
      uploadUrl: "https://www.58zltc.com/api/Upload/uploads/",
      imgdata: {},
      imageUrl: "",
    }
  },
  mounted(){
    this.imgdata = {
      app_id: this.app_id,
      token: this.token,
      type: "1",
      file_group: "1"
    };
    if(localStorage.getItem('baseStatus') == 'test'){
      this.uploadUrl = "https://cs.58zltc.com/api/Upload/uploads/"
    };
    this.getData();
  },
  methods:{
    // 获取设置
    getData(){
      getShareConfig({app_id: this.app_id}).then(res => {
        if(res.code == 200){
          this.sList = [];
          this.sList2 = [];
          this.formData = Object.assign({},res.data)
          this.imageUrl = this.formData.share_pic;
          this.formData.coupon.split(',').forEach((item,index) => {
            var idx = this.sList.findIndex(x => x.id == item)
            if(idx == -1){
              var data = {
                id: item,
                name: this.formData.coupon_list[index],
                choseNum: 1
              }
              this.sList.push(data)
            }else{
              this.sList[idx].choseNum += 1;
            }
          })
          this.formData.share_coupon.split(',').forEach((item,index) => {
            var idx = this.sList2.findIndex(x => x.id == item)
            if(idx == -1){
              var data = {
                id: item,
                name: this.formData.share_coupon_list[index],
                choseNum: 1
              }
              this.sList2.push(data)
            }else{
              this.sList2[idx].choseNum += 1;
            }
          })
          delete this.formData.create_time;
          delete this.formData.update_time;
        }else{
          this.$message(res.msg)
        }
      })
    },
    //选择优惠券
    getCommod(data) {
      console.log(data);
      this.sList = data;
      this.showSelecter = false;
    },
    //选择优惠券
    getCommod2(data) {
      console.log(data);
      this.sList2 = data;
      this.showSelecter2 = false;
    },
    //删除选择的优惠券
    delTagItem(i) {
      console.log(i);
      this.sList.splice(i, 1);
    },
    //删除选择的优惠券
    delTagItem2(i) {
      console.log(i);
      this.sList2.splice(i, 1);
    },
    handleLogoSuccess(res, file) {
      console.log(res);
      this.$message(res.msg);
      if (res.code == 200) {
        this.formData.share_pic = res.data.url;
      }
      this.imageUrl = URL.createObjectURL(file.raw);
    },
    beforeLogoUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
      }
      return isLt2M;
    },
    save(){
      var coupon1 = [],coupon2 = [];
      this.sList.forEach(item => {
        for(var i = item.choseNum;i>0;i--){
          coupon1.push(item.id)
        }
      })
      console.log(coupon1);
      this.sList2.forEach(item => {
        for(var i = item.choseNum;i>0;i--){
          coupon2.push(item.id)
        }
      })
      console.log(coupon2);
      var data = Object.assign({},this.formData);
      data.app_id = this.app_id;
      data.coupon = coupon1.join(',')
      data.share_coupon = coupon2.join(',')
      console.log(data);
      // return false;
      setShareConfig(data).then(res => {
        if(res.code == 200){
          this.$message.success('保存成功');
          this.getData();
        }else{
          this.$message(res.msg);
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.page_content{
  background:  #f2f2f6;
  height: calc(100vh - 50px);
  overflow: auto;
  padding-bottom: 78px;
  .content{
    background: #fff;
    margin: 15px 20px 0 20px;
    padding-bottom: 20px;
    .label{
      font-size: 14px;
      font-weight: 600;
      padding: 20px;
    }
  }
}
.input_box{
  width: 220px
}
.avatar-uploader .el-upload {
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
  border: 1px dashed #8c939d !important;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.align_c{
  text-align: center;
  line-height: 60px;
  background-color: #fff;
  margin-top: 18px;
  position: fixed;
  width: 100%;
  bottom: 0;
}
</style>